import { createFileRoute } from '@tanstack/react-router';
import { MindMapCanvas } from '@/features/mindmaps/components/MindMapCanvas';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/mindmaps')({
  component: MindMapsPage,
});

function MindMapsPage() {
  return (
    <PermissionGate permission={Permission.MIND_MAPS_VIEW}>
      <div className="flex flex-col h-[calc(100vh-4rem)]">
        <div className="px-4 pt-4 pb-2">
          <h1 className="text-lg font-semibold">Mapas Mentais</h1>
          <p className="text-sm text-muted-foreground">
            Crie mapas mentais expansíveis com links e arquivos anexados aos nós.
          </p>
        </div>
        <div className="flex-1 min-h-0">
          <MindMapCanvas />
        </div>
      </div>
    </PermissionGate>
  );
}
